import axios from "axios";
import {API_URL} from "@/api/base";
import {auth} from "@/data/auth";

const authHeaders = async () => ({
    'Authorization': `Bearer ${await auth.getAccessToken()}`
});

export async function getList(company_id, query = '') {
    query = new URLSearchParams(query).toString()
    return await axios.get(
        `${API_URL}/v1/task/list?company_id=${company_id}&${query}`,
        {headers: await authHeaders()}
    )
}

export async function getInfo(task_id) {
    return await axios.get(
        `${API_URL}/v1/task/${task_id}/info`,
        {headers: await authHeaders()}
    )
}

export async function getReport(task_id, query = '') {
    const queryString = new URLSearchParams(query).toString()
    return await axios.get(
        `${API_URL}/v1/task/${task_id}/report?${queryString}`,
        {headers: await authHeaders()}
    )
}

export async function downloadReportCsv(task_id) {
    const res = await fetch(`${API_URL}/v1/task/${task_id}/report/csv`, {
        headers: await authHeaders(),
    })
    if (!res.ok) {
        throw new Error(`CSV download failed: ${res.status}`)
    }
    const blob = await res.blob()
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `task_${task_id}_report.csv`
    document.body.appendChild(a)
    a.click()
    a.remove()
    URL.revokeObjectURL(url)
}
